exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter[data-v-75d11bce] {\n  font-size: 0.5rem;\n  font-weight: 500;\n  border-radius: 0;\n  background-color: #fcfcfc;\n  color: #aeaeae;\n}\n@media screen and (min-width: 576px) {\n.filter[data-v-75d11bce] {\n    font-size: 0.7rem;\n}\n}\n@media screen and (max-width: 992px) {\n.scroll-container[data-v-75d11bce] {\n    overflow-x: scroll;\n}\n.scroll-container > .row[data-v-75d11bce] {\n    min-width: 768px !important;\n}\n}", ""]);

// exports
